import { faCircleDollar, faFile } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { Moment } from 'moment-timezone';
import { FunctionComponent, ReactNode, useState } from 'react';
import Invoices from './Invoices/Invoices';
import Transactions from './Transactions';
import styles from './TransactionsTabs.module.scss';

type TabId = 'transactions' | 'invoices';

interface TransactionsTabsProps {
    className?: string;
    clientId?: number;
    emptyState?: ReactNode;
    initialCategoryId?: string;
    initialDate?: Moment;
    initialMarketplaceIds?: number[];
}

export const TransactionsTabs: FunctionComponent<TransactionsTabsProps> = props => {
    const [selectedTab, setSelectedTab] = useState<TabId>('transactions');

    const { className, ...transactionsProps } = props;

    return (
        <div className={clsx(styles.root, className)}>
            <div className={styles.tabs}>
                <div
                    className={clsx(styles.tab, {
                        [styles.tabActive]: selectedTab === 'transactions'
                    })}
                    onClick={() => setSelectedTab('transactions')}
                >
                    <FontAwesomeIcon icon={faCircleDollar} />
                    Transactions
                </div>
                <div
                    className={clsx(styles.tab, {
                        [styles.tabActive]: selectedTab === 'invoices'
                    })}
                    onClick={() => setSelectedTab('invoices')}
                >
                    <FontAwesomeIcon icon={faFile} />
                    Invoices
                </div>
            </div>
            <div className={styles.content}>
                {selectedTab === 'transactions' && <Transactions {...transactionsProps} />}
                {selectedTab === 'invoices' && <Invoices {...transactionsProps} />}
            </div>
        </div>
    );
};

export default TransactionsTabs;
